import JSDB from '../../fromKotlin/nk';

const API_BASE = 'https://nihulkav.online:4000';

function getHeaders(): HeadersInit {
    const token = (JSDB() as any).getToken?.();
    return {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
    };
}

function getCompanyId(): string {
    try {
        const db = JSDB() as any;
        if (typeof db.getCompanyId === 'function') return String(db.getCompanyId());
        return '';
    } catch {
        return '';
    }
}

/** Ready-to-send `#pattern` block comes from Hub for this inbox. Nexil dumps it as-is. */
export type HubWhatsappTemplate = {
    id?: string;
    name?: string;
    language?: string | null;
    category?: string | null;
    status?: string | null;
    pattern?: string;
    body_preview?: string;
    channel_account_id?: string;
};

export async function fetchHubWhatsappTemplates(
    channelAccountId: string,
): Promise<HubWhatsappTemplate[]> {
    const inboxId = String(channelAccountId || '').trim();
    const companyId = getCompanyId();
    if (!inboxId || !companyId) return [];

    const res = await fetch(`${API_BASE}/whatsapp/hub_templates`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({
            company_id: companyId,
            channel_account_id: inboxId,
        }),
    });
    const json = await res.json().catch(() => null);
    if (!res.ok || json?.status !== 'SUCCESS') {
        throw new Error(json?.status_msg || 'לא ניתן לטעון תבניות ווטסאפ');
    }
    return Array.isArray(json.data) ? json.data : [];
}

export type CreateHubWhatsappTemplateInput = {
    channelAccountId: string;
    name: string;
    language?: string;
    category?: string;
    bodyText: string;
    bodyExamples?: string[];
    footerText?: string;
    headerFormat?: string;
    headerFileBase64?: string;
    headerFileName?: string;
    headerFileType?: string;
    buttons?: Array<{
        type: string;
        text?: string;
        url?: string;
        example?: string;
    }>;
};

export type CreateHubWhatsappTemplateResult = {
    templateId?: string;
    status?: string;
    name?: string;
    pattern?: string;
};

export async function createHubWhatsappTemplate(
    input: CreateHubWhatsappTemplateInput,
): Promise<CreateHubWhatsappTemplateResult> {
    const inboxId = String(input.channelAccountId || '').trim();
    const companyId = getCompanyId();
    if (!inboxId || !companyId) {
        throw new Error('חסר מזהה חברה או תיבת ווטסאפ');
    }
    const res = await fetch(`${API_BASE}/whatsapp/hub_templates/create`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({
            company_id: companyId,
            channel_account_id: inboxId,
            name: input.name,
            language: input.language || 'he',
            category: input.category || 'UTILITY',
            body_text: input.bodyText,
            body_examples: input.bodyExamples || [],
            footer_text: input.footerText || '',
            header_format: input.headerFormat || 'NONE',
            header_file_base64: input.headerFileBase64 || '',
            header_file_name: input.headerFileName || '',
            header_file_type: input.headerFileType || '',
            buttons: input.buttons || [],
        }),
    });
    const json = await res.json().catch(() => null);
    if (!res.ok || json?.status !== 'SUCCESS') {
        throw new Error(json?.status_msg || 'לא ניתן ליצור את התבנית');
    }
    return (json.data || {}) as CreateHubWhatsappTemplateResult;
}
